
import { Union, Record } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { User_$reflection } from "../../../../Shared/User.js";
import { union_type, class_type, record_type, list_type } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { CustomerConfiguration_$reflection, RequestedValue$1_$reflection } from "../../../../Shared/Shared.js";
import { Location_$reflection } from "../../../../Shared/Location.js";
import { UserRoleAssignmentDto_$reflection, RoleDefinition_$reflection } from "../../../../Shared/Roles.js";

export class State extends Record {
    constructor(Users, CustomerConfiguration, Locations, Roles, Assignments) {
        super();
        this.Users = Users;
        this.CustomerConfiguration = CustomerConfiguration;
        this.Locations = Locations;
        this.Roles = Roles;
        this.Assignments = Assignments;
    }
}

export function State_$reflection() {
    return record_type("Settings.UserManagement.Users.Overview.Types.State", [], State, () => [["Users", RequestedValue$1_$reflection(list_type(User_$reflection()))], ["CustomerConfiguration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["Locations", RequestedValue$1_$reflection(list_type(Location_$reflection()))], ["Roles", RequestedValue$1_$reflection(list_type(RoleDefinition_$reflection()))], ["Assignments", RequestedValue$1_$reflection(list_type(UserRoleAssignmentDto_$reflection()))]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CustomerConfigurationFetched", "LocationsFetched", "UsersFetched", "RolesFetched", "AssignmentsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.UserManagement.Users.Overview.Types.Msg", [], Msg, () => [[["Item", CustomerConfiguration_$reflection()]], [["Item", list_type(Location_$reflection())]], [["Item", list_type(User_$reflection())]], [["Item", list_type(RoleDefinition_$reflection())]], [["Item", list_type(UserRoleAssignmentDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

